import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import brand_details from "@/data/brand_details";
import get_sectors from "@/data/sectors";
import get_mining_menu_items, { default_mining_menu_item } from "@/data/mining";
import is_admin_user from "@/utils/auth_user";

// IMPORT UTILITIES
import { get_user_profile } from "@/router";

const details = brand_details();

export default {
  name: "MiningSidebar",

  components: {
    SidebarShell,
    SidebarContext
  },

  props: {
    active_item: {
      type: String,
      default: default_mining_menu_item
    },
    can_view_portfolio: {
      type: Boolean,
      default: false
    }
  },

  emits: ["mining-menu-selected", "select-sector", "go-overview"],

  data() {
    return ({
      // SECTORS SHOWN IN THE CONTEXT DROPDOWN
      sectors: get_sectors(),

      // MENU STATE
      menu_items: get_mining_menu_items(),
      default_menu_item: default_mining_menu_item,
      active_menu_item: this.active_item || default_mining_menu_item,
      dropdownOpen: false,

      // BRAND
      brand_name: details.name,
      brand_subtitle: details.subtitle,
      short_logo: details.logo,
      entity_name: details.sub_entity_name,
      entity_subtitle: details.sub_entity_subtitle,

      // FOOTER
      full_name: "Guest User",
      initials: "GU",
      is_admin: false
    });
  },

  watch: {
    active_item(new_item) {
      this.active_menu_item = new_item || default_mining_menu_item;
    }
  },

  mounted() {
    this.load_user_name();
  },

  methods: {
    /** FOOTER NAME / INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";
      this.is_admin = is_admin_user(user);

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();

      this.full_name = name;
      this.initials = initials || "GU";
    },

    /** CONTEXT DROPDOWN ACTIONS */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    select_sector(sector) {
      this.dropdownOpen = false;
      this.$emit("select-sector", sector);
    },

    go_to_overview() {
      this.dropdownOpen = false;
      this.$emit("go-overview");
    },

    /** MENU SELECTION */
    select_menu_item(menu_item) {
      this.active_menu_item = menu_item;
      this.dropdownOpen = false;
      this.$emit("mining-menu-selected", menu_item);
    },

    badge_class(item) {
      return item.badge_variant === "warning"
        ? "bg-warning-subtle text-warning-emphasis border-warning-subtle"
        : "bg-danger-subtle text-danger-emphasis border-danger-subtle";
    }
  }
};
